module.exports = __webpack_public_path__ + "img/room_UDI.6671c62b.png";